ACC.address = {
  dataAddress: 'data-address-id',
  responseAddressData: '',
  selectedAddressLabel: 'selectedAddress',
  showRegion: '.showRegion',

  bindAll: function() {
    $('div.checkout_summary_flow_c .change_address_button').on('click', this.handleChangeAddressButtonClick);
    $('.ph-shipping__procceed').on('click', this.validateCheckoutShipping);
    $('#deliveryPhone').on('keyup', this.validatePhoneNumber);

    if ($('.ph-allowDropShip').text() === 'true') {
      $('.ph-allow-dropship').find('.ph-forminput').on('blur', this.getDeliveryModeDynamically);
    }

    this.bindCreateUpdateAddressForm();

    $.extend({
      postJSON: function(url, data, callback) {
        return $.post(url, data, callback, 'json');
      }
    });

    ACC.address.bindingOneTimeAddressDomEvents();
    ACC.address.bindingDeliveryModesDom();
  },
  bindingOneTimeAddressDomEvents: function() {
    $('#addtoaddressbook').on('click', function() {
      $('.ph-addtoaddressbook__notcheckedmsg, .ph-addtoaddressbook__checkedmsg').toggle();
    });

    $('#country').on('change', function() {
      $('.ph-spinnerorder').show();

      var countryValue = $(this).val(),
          countryPath = $(this).attr('data-url');

      if (countryValue !== '') {
        $.ajax({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
          },
          url: countryPath,
          type: 'GET',
          data: {
            country: countryValue
          },
          dataType: 'json',
          success: function(result) {
            $('#region').empty();

            if (result.length > 0) {
              $.each(result, function(k, v) {
                $('#region').append('<option isocodeshort="' + v.isocodeShort + '"  value="' + v.isocode + '">' + v.name + '</option>');
              });
            }

            $('#region').selectBox('refresh');
            $('.ph-spinnerorder').hide();
          }
        });
      }
    });
  },
  bindingDeliveryModesDom: function() {
    var $deliverymodes = $('#deliverymodes');

    $deliverymodes.find('.ph-deliverymode__custommultiple .atp-product').on('click', function() {
      $deliverymodes.find('.ph-deliverymode__custommultiple #radio3').prop('checked', true);

      ACC.address.sendAtpData();
    });
    $deliverymodes.find('.ph-deliverymode .radio').on('click', function() {
      var currentRadioId = $(this).attr('id');

      if (currentRadioId === 'radio1' || currentRadioId === 'radio2') {
        $deliverymodes.find('.ph-deliverymode__custommultiple .atp-product').prop('checked', false);
      }

      ACC.address.sendAtpData();
    });

    var atpItemCount = $('#atpItemCount').val();

    if (atpItemCount > 0) {
      ACC.address.sendAtpData();
    }
  },
  getDeliveryModeDynamically: function() {
    $('.ph-dropship-error').hide();

    var dropShipFormPicked = false,
        isValidated = true,
        $dropshipField = $('.ph-allow-dropship');

    $dropshipField.find('input.ph-forminput,select.ph-forminput').each(function() {
      if ($.trim($(this).val()) === '' || $(this).val() === null) {
        isValidated = false;
      } else {
        dropShipFormPicked = true;
      }
    });

    if ($dropshipField.find('#postCode').val() !== '') {
      ACC.address.validationDropShipping();
    }

    if (dropShipFormPicked === true && isValidated === true && ACC.address.validationDropShipping()) {
      $('.ph-dropship-error').hide();

      var addtoaddressbook = 'false';

      if ($dropshipField.find('#addtoaddressbook').prop('checked')) {
        addtoaddressbook = 'true';
      }

      $.ajax({
        type: 'POST',
        url: '/checkout/single/summary/createOneTimeShippingAddress.json',
        dataType: 'json',
        data: {
          firstName: $dropshipField.find('.ph-forminput[name=firstName]').val(),
          line1: $dropshipField.find('.ph-forminput[name=line1]').val(),
          line2: $dropshipField.find('.ph-forminput[name=line2]').val(),
          townCity: $dropshipField.find('.ph-forminput[name=townCity]').val(),
          country: $dropshipField.find('.ph-forminput[name=country]').val(),
          regionIso: $dropshipField.find('.ph-forminput[name=regionIso]').val(),
          postcode: $dropshipField.find('.ph-forminput[name=postcode]').val(),
          addtoaddressbook: addtoaddressbook
        },
        success: function(otaResponse) {
          ACC.address.reGenerateShippingModes(otaResponse.deliveryData);


          if (typeof otaResponse.addressData !== 'undefined') {
            ACC.address.generateAtpData(otaResponse.addressData);
          }

          ACC.address.reGenerateDeliveryModes(otaResponse.deliveryData);
          ACC.address.bindingDeliveryModesDom();

          if ($('.ph-checkout-shipping__footer').find('.ph-clicked').length > 0) {
            ACC.address.validateCheckoutShipping();
          }
        }
      });
    }
  },
  generateAtpData: function(addressData) {
    var atpItemCount = 0,
        consolidatedMsg = '',
        atpRadioButtons = '';

    if (String(addressData.customerDecision) !== 'null' && addressData.customerDecision.length > 0) {
      for (var cd = 0; cd < addressData.customerDecision.length; cd = cd + 1) {
        var atpAddressItem = addressData.customerDecision[cd];

        if (atpAddressItem.quantityRequested > atpAddressItem.quantityAvailable) {
          $('#atpCheck').val('true');
          atpItemCount = atpItemCount + 1;
          $('.atpBasedLabelClass').removeClass('hidden');
          consolidatedMsg = consolidatedMsg + '<li class="ph-atplist ph-pt-1"><span class="ph-atp-productname ph-d-block">' + atpAddressItem.productName + '</span><span class="ph-atpqty-display ph-d-block">You ordered ' + atpAddressItem.quantityRequested + ' but only ' + atpAddressItem.quantityAvailable + ' are in stock</span>';

          atpRadioButtons = atpRadioButtons + '<div class="ph-atp-product__container">';
          atpRadioButtons = atpRadioButtons + '<label for="atp-product' + cd + '" class="ph-labelregcontainer  ph-mt-1">';
          atpRadioButtons = atpRadioButtons + '<span class="ph-atp-product__checkbox">' + atpAddressItem.productName + '</span>';
          atpRadioButtons = atpRadioButtons + '<input class="atp-product" id="atp-product' + cd + '" name="atp-product' + cd + '" class="ph-m-0 disable" type="checkbox" value="' + cd + '">';
          atpRadioButtons = atpRadioButtons + '<input type="hidden" class="atpItem" data-productId="' + atpAddressItem.productId + '" data-quantityAvailable="' + atpAddressItem.quantityAvailable + '" data-quantityRequested="' + atpAddressItem.quantityRequested + '" id="atpItemIndex' + cd + '" value="' + cd + '">';
          atpRadioButtons = atpRadioButtons + '<span class="ph-regcheckmark"></span>';
          atpRadioButtons = atpRadioButtons + '</label>';
          atpRadioButtons = atpRadioButtons + '</div>';
        }
      }
    }

    $('#atpItemCount').val(atpItemCount);

    if (consolidatedMsg !== '') {
      ACC.address.atpBasedDeliveryMode(consolidatedMsg, atpRadioButtons);
    }
  },
  atpBasedDeliveryMode: function(consolidatedMsg, atpRadioButtons) {
    var atpItemList = '';

    atpItemList = atpItemList + '<div class="ph-atp-message ph-col-12  ph-col-md-12  ph-col-lg-8 ph-mt-2 ph-mb-2">';
    atpItemList = atpItemList + '<div class="ph-atp-message_title">' + $('.atp-message_title').text() + '</div>';
    atpItemList = atpItemList + '<div class="ph-atp-message_items">';
    atpItemList = atpItemList + '<ul class="ph-p-0 ph-m-0">' + consolidatedMsg + '</ul>';
    atpItemList = atpItemList + '</div>';
    atpItemList = atpItemList + '</div>';
    $('#atpItemList').html(atpItemList);


    var newDeliveryMode = '';

    newDeliveryMode = newDeliveryMode + '<div class="ph-deliverymode__custommultiple ph-col-12 ph-col-md-12  ph-col-lg-8 ph-pl-0 ph-float-left">';
    newDeliveryMode = newDeliveryMode + '<label class="ph-radiocontainer ph-col-12 ph-float-left ph-pl-4">';
    newDeliveryMode = newDeliveryMode + '<input type="radio" name="completeDelivery" class="radio" id="radio3"  value="Split Shipment"/>';
    newDeliveryMode = newDeliveryMode + $('.custommultiple-message').text();
    newDeliveryMode = newDeliveryMode + '<div class="ph-deliverymode_msg ph-pt-1 ph-pb-1">';
    newDeliveryMode = newDeliveryMode + atpRadioButtons;
    newDeliveryMode = newDeliveryMode + '</div>';
    newDeliveryMode = newDeliveryMode + '<span class="ph-checkmark ph-deliverytypeselect"></span>';
    newDeliveryMode = newDeliveryMode + '</label>';
    newDeliveryMode = newDeliveryMode + '</div>';
    $('#atpAdditionalMode').html(newDeliveryMode);
  },
  reGenerateShippingModes: function(deliveryData) {
    var shippingmodesHtml = '';

    if (typeof deliveryData.deliverymodes !== 'undefined' && deliveryData.deliverymodes.length > 0) {
      shippingmodesHtml = shippingmodesHtml + '<div class="ph-shipping-mode__title ">' + $('.shippingmodetitle').text() + '</div>';

      for (var dm = 0; dm < deliveryData.deliverymodes.length; dm = dm + 1) {
        var deliverymode = deliveryData.deliverymodes[dm];

        shippingmodesHtml = shippingmodesHtml + '<div class="form_field-container">';


        shippingmodesHtml = shippingmodesHtml + '<label class="form_field-label select ph-radiocontainer ph-pt-1 ph-pl-4 checked" for="' + deliverymode.code + '">' + deliverymode.name + '&nbsp;&nbsp;';

        if (String(deliverymode.description) !== 'null') {
          shippingmodesHtml = shippingmodesHtml + deliverymode.description + '&nbsp;&nbsp;';
        }

        if (String($('.showDeliveryCostForCountry').text()) === 'true' && String(deliverymode.deliveryCost) !== 'null') {
          shippingmodesHtml = shippingmodesHtml + deliverymode.deliveryCost.formattedValue + '&nbsp;&nbsp;';
        }

        if (dm === 0) {
          shippingmodesHtml = shippingmodesHtml + '<input checked="checked" type="radio" name="delivery" class="ph-deliverymethod-radio" value="' + deliverymode.code + '" id="' + deliverymode.code + '"/>';
        } else {
          shippingmodesHtml = shippingmodesHtml + '<input type="radio" name="delivery" class="ph-deliverymethod-radio" value="' + deliverymode.code + '" id="' + deliverymode.code + '"/>';
        }

        shippingmodesHtml = shippingmodesHtml + '<span class="ph-checkmark ph-deliverymethodselect"></span>';
        shippingmodesHtml = shippingmodesHtml + '</label>';


        shippingmodesHtml = shippingmodesHtml + '</div>';
      }
    }

    $('#shippingmodes').html(shippingmodesHtml);
  },
  reGenerateDeliveryModes: function(deliveryData) {
    if (typeof deliveryData.deliverymodes !== 'undefined' && deliveryData.deliverymodes.length > 0) {
      $('#deliverymodes').removeClass('hidden');
    }

    if (String(deliveryData.isCompleteDelivery) === 'true') {
      $('.ph-deliverymode').find('#radio1').prop('checked', true);
      $('.ph-deliverymode').find('#radio2').prop('checked', false);
    } else {
      $('.ph-deliverymode').find('#radio1').prop('checked', false);
      $('.ph-deliverymode').find('#radio2').prop('checked', true);
    }

    if (String(deliveryData.disableDeliveryOptions) === 'true' && String($('#atpCheck').val()) !== 'true') {
      $('.ph-deliverymode').find('#radio1').prop('disabled', true);
      $('.ph-deliverymode').find('#radio2').prop('disabled', true);
      $('.ph-deliverymode').find('#radio2').prop('checked', true);
    } else {
      $('.ph-deliverymode').find('#radio1').prop('disabled', false);
      $('.ph-deliverymode').find('#radio2').prop('disabled', false);
    }

    if (String($('#atpCheck').val()) === 'true') {
      $('.ph-onlyforatp').removeClass('hidden');
    }
  },
  validationDropShipping: function() {
    $('.ph-selectaddress-error').hide();

    var validationStatus = true;

    $('.ph-allow-dropship input.ph-forminput, .ph-allow-dropship select.ph-forminput').each(function() {
      if ($.trim($(this).val()) === '' || $(this).val() === null) {
        $(this).parent('.form_field-input').addClass('ph-form_field_error');
        validationStatus = false;
      } else {
        $(this).parent('.form_field-input').removeClass('ph-form_field_error');
      }
    });

    var postCodeInput = $('.ph-allow-dropship').find('#postCode'),
        countryId = '';

    if ($('.ph-country-selectbox-holder').length > 0) {
      countryId = '#country';
    }

    if (ACC.validation.postalCode(postCodeInput.val(), countryId)) {
      postCodeInput.parent('.form_field-input').addClass('ph-form_field_error');
      validationStatus = false;
    } else {
      postCodeInput.parent('.form_field-input').removeClass('ph-form_field_error');
    }

    $('.ph-allow-dropship').find('.ph-form_field_error .ph-forminput').on('blur', function() {
      if ($.trim($(this).val()) !== '') {
        $(this).parent('.form_field-input').removeClass('ph-form_field_error');
      }
    });

    if (validationStatus === false) {
      $('.ph-dropship-error').show();
    } else {
      $('.ph-dropship-error').hide();
    }

    return validationStatus;
  },
  validateCheckoutShipping: function() {
    $('.ph-selectaddress-error').hide();
    $('.ph-dropship-error').hide();
    $('.ph-deliverymode-error').hide();
    $('.ph-atpresponse-error').hide();
    $('.ph-selectshipping-message').addClass('hidden');

    var validationStatus = true,
        deliveryModesAvailable = '',
        dropShipFormPicked = false;

    if ($('.ph-allowDropShip').text() === 'true') {
      $('.ph-allow-dropship').find('input.ph-forminput,select.ph-forminput').each(function() {
        $(this).parent('.form_field-input').removeClass('ph-form_field_error');

        if ($(this).val() && $(this).val() !== '') {
          dropShipFormPicked = true;
          $('.ph-dropship-error').show();
        }
      });
    }

    if ($('#deliveryAddressOk').val() !== 'true' && dropShipFormPicked === false) {
      $('.ph-selectaddress-error').show();
      validationStatus = false;
    }


    if (dropShipFormPicked === true && $('.ph-allowDropShip').text() === 'true' && $('#deliveryAddressOk').val() !== 'true') {
      validationStatus = ACC.address.validationDropShipping();
    }

    if ($('#shippingmodes').find('.ph-deliverymethod-radio').length <= 0) {
      validationStatus = false;
      deliveryModesAvailable = false;
    }

    ACC.address.validateCheckoutShippingAction(validationStatus, deliveryModesAvailable);
  },
  validateCheckoutShippingAction: function(validationStatus, deliveryModesAvailable) {
    if (validationStatus === true) {
      $('.ph-dropship-error').hide();
      $('.ph-spinnerorder').removeClass('hidden');
      $('#addressForm').submit();

      if (window.tempEvent && window.tempEvent.length > 0) {
        window.eddlEvents.push(window.tempEvent[0]);
        window.tempEvent = [];
      }
    } else if (deliveryModesAvailable === '') {
      $('.ph-shipping__procceed').removeClass('ph-clicked');
      $('.ph-selectshipping-message').removeClass('hidden');
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');
    } else if (deliveryModesAvailable === false) {
      $('.ph-shipping__procceed').addClass('ph-clicked');
    }
  },
  validatePONumber: function(evt) {
    var event = evt || window.event,
        val = event.target.value,
        filtered = val.replace(/[,%<">'#]$/, '');

    if (filtered !== val) {
      event.target.value = filtered;
    }
  },


  validatePhoneNumber: function(evt) {
    var event = evt || window.event,
        val = event.target.value,
        filtered = val.replace(/[^0-9-(-)- ,.-/+]/g, '');

    if (filtered !== val) {
      event.target.value = filtered;
    }
  },

  validateCustomerAccountNumber: function(evt) {
    var event = evt || window.event,
        val = event.target.value,
        filtered = val.replace(/[^0-9]/g, '');

    if (filtered !== val) {
      event.target.value = filtered;
    }
  },

  validatePostCode: function() {
    var string = $(this).val();

    if (string.match(/^\d{5}-\d{4}$/gm) || string.match(/^\d{5}$/gm)) {
      $(this).parents('.error_span').removeClass('form_field_error');

      return true;
    }

    $(this).parents('.error_span').addClass('form_field_error');

    return false;
  },
  handleChangeAddressButtonClick: function() {
    var dataAddressId = $(this).attr(ACC.address.dataAddress),
        allowDropShip = $('.ph-allowDropShip').text(),
        restrictDropShip = $('.ph-dropship').html(),
        salesOrgVal = $('.ph-salesOrgValSel').html();

    if (dataAddressId !== '' && allowDropShip === 'true' && restrictDropShip === 'false') {
      $('.ph-checkout_shiping__dropship').show();
      $(this).parent().find('.ph-deliveryaddress__select').show();
      $(this).hide();
      $('.ph-setas-default').hide();
      $('.ph-default-address__title').hide();
      $('.ph-default-address__info').hide();
      $('#deliveryAddressOk').val('false');
      $('#shippingmodes').html('');
      $('#deliverymodes').addClass('hidden');
    } else if (($('.ph-isOneStore').text() === 'true') && (salesOrgVal !== '')) {
      $.getJSON('/checkout/single/summary/getDeliveryAddressesForOneStore.json?salesOrg=' + salesOrgVal, ACC.address.handleAddressDataLoad);
    } else {
      $.getJSON($('.ph-getDeliveryAddressesUrl').text(), ACC.address.handleAddressDataLoad);
    }
  },

  handleAddressDataLoad: function(data) {
    ACC.address.setupDeliveryAddressPopupForm(data);

    // Show the delivery address popup
    var popupHeight = '80%';

    if ($(window).width() < 768) {
      popupHeight = '100%';
    }

    $.colorbox({
      inline: true,
      href: '#popup_checkout_delivery_address4',
      scrolling: true,
      height: popupHeight,
      width: '100%',
      maxWidth: 640,
      overlayClose: false,
      close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('#colorbox').addClass('ph-shipping-popup');
        $('#cboxContent').addClass('ph-cbox-content');
        $('html').addClass('ph-hideoverflow__shippingpopup');

        if (navigator.appVersion.indexOf('Edge') !== -1) {
          $('.ph-formlabel').addClass('ph-formlabeledge');
        }

        if ($('#cboxWrapper').find('.existing_address').length > 3) {
          $('.ph-shipping-searchaddressbox').show();
        } else {
          $('.ph-shipping-searchaddressbox').hide();
        }

        $('#cboxWrapper #myInput').each(function() {
          var inputVal = $(this).val();

          $(this).focus();
          $(this).keypress(function() {
            if (this.value === inputVal) {
              this.value = '';
            }
          });
        });

        ACC.address.handleSelectedAddressForRepairs();
        ACC.search.searchAddress();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass('ph-hideoverflow__shippingpopup');
        $('#cboxWrapper #myInput').each(function() {
          $(this).focus();
        });
      }
    });
  },
  handleSelectedAddressForRepairs: function() {
    var selectedAddressId = '#ph-' + localStorage.getItem(ACC.address.selectedAddressLabel),
        addressNotSelected = ' .ph-shippingaddress__notselected',
        addressSelected = 'ph-shippingaddress__selected',
        selectedmsg = 'ph-shippingaddress__selectedmsg',
        selectedMsgText = $('.ph-repairs_selectAddressPopupMsg').text(),
        selectedTemplate = '<div class="ph-shippingaddress__selectedmsg ph-float-left ph-col-12 ph-col-md-3 ">' +
        '<span class="ph-icon-checkmark"></span>' +
        selectedMsgText +
        '</div>';

    if ($('.ph-repairs_shippingpage').length > 0 || $('#thirtyDayHome').length > 0) {
      $('.' + selectedmsg).hide();
      $(selectedAddressId + addressNotSelected).after(selectedTemplate);
      $(selectedAddressId + addressNotSelected).removeClass('ph-col-md-12').addClass('ph-col-md-9');
      $('.' + addressSelected).removeClass(addressSelected).addClass('ph-shippingaddress__notselected');
      $(selectedAddressId + addressNotSelected).addClass(addressSelected);
      $(selectedAddressId + ' .' + selectedmsg).show();
    }
  },

  setupDeliveryAddressPopupForm: function(data) {
    // Fill the available delivery addresses
    var allowDropShipVal = '',
        allowDropShipClass = '.ph-allowDropShip';

    if ($(allowDropShipClass).text().length > 0) {
      allowDropShipVal = JSON.parse($(allowDropShipClass).text());
    }

    $('.delivery_addresses_list').html($('#deliveryAddressesTemplate').tmpl({
      allowDropShip: allowDropShipVal,
      addresses: data,
      displayCodeRegionIso: $(ACC.address.showRegion).html()
    }));

    // Handle selection of address
    ACC.address.responseAddressData = data;
    $('.delivery_addresses_list .use_address').on('click', ACC.address.handleSelectExistingAddressClick);


    // Handle edit address
    $('.delivery_addresses_list button.edit').on('click', ACC.address.handleEditAddressClick);
    // Handle default address
    $('.delivery_addresses_list button.default').on('click', ACC.address.handleDefaultAddressClick);
  },

  emptyAddressForm: function() {
    var options = {
      url: document.querySelector('.ph-getDeliveryAddressFormUrl').textContent,
      data: {
        addressId: '',
        createUpdateStatus: ''
      },
      type: 'GET',
      success: function(data) {
        $('#create_update_address_form_container_div').html(data);
        ACC.address.bindCreateUpdateAddressForm();
      }
    };

    $.ajax(options);
  },

  handleSelectExistingAddressClick: function() {
    $.colorbox.toggleLoadingOverlay();

    var addressId = $(this).attr(ACC.address.dataAddress),
        setAddressUrl = $('.ph-setDeliveryAddressUrl').text();

    if ($('#createrepair').length > 0) {
      setAddressUrl = $('.ph-setRepairsDeliveryAddress').text();
      localStorage.setItem(ACC.address.selectedAddressLabel, addressId);
    }

    if ($('#thirtyDayHome').length > 0) {
      ACC.address.showSelectedAddressForThirtyDayMask(addressId);
    } else {
      $.postJSON(setAddressUrl, {
        addressId: addressId
      }, ACC.address.handleSelectExitingAddressSuccess);
    }

    return false;
  },
  showSelectedAddressForThirtyDayMask: function(selectedAddressId) {
    var data = ACC.address.filterAddressByID(selectedAddressId),
        shippingAddrElement = 'ph-thirtydaymask-shippingaddr';

    localStorage.setItem(ACC.address.selectedAddressLabel, selectedAddressId);
    $('.' + shippingAddrElement).html($('#thirtyDayAddressTemplate').tmpl(data));
    $('.' + shippingAddrElement).show();

    if ($('.ph-asmUserFlag').html() === 'false') {
      $('.ph-thirtydaymask_startbtn').removeClass('ph-disabledbutton');
    }


    $.colorbox.toggleLoadingOverlay();
    $.colorbox.close();
  },
  filterAddressByID: function(addressID) {
    var selectedAddress = '',
        address = {};

    selectedAddress = ACC.address.responseAddressData.filter(function(item) {
      return item.id === addressID;
    });

    address.deliveryAddress = selectedAddress[0];
    address.displayCodeRegionIso = $(ACC.address.showRegion).html();

    return address;
  },
  handleEditAddressClick: function() {
    var addressId = $(this).attr(ACC.address.dataAddress),
        options = {
          url: document.querySelector('.ph-getDeliveryAddressFormUrl').textContent,
          data: {
            addressId: addressId,
            createUpdateStatus: ''
          },
          target: '#create_update_address_form_container_div',
          type: 'GET',
          success: function() {
            ACC.address.bindCreateUpdateAddressForm();
          }
        };

    $(this).ajaxSubmit(options);

    return false;
  },

  handleDefaultAddressClick: function() {
    var addressId = $(this).attr('data-address'),
        options = {
          url: document.querySelector('.ph-setDefaultAddressUrl').textContent,
          data: {
            addressId: addressId
          },
          type: 'GET',
          success: function(data) {
            ACC.address.setupDeliveryAddressPopupForm(data);
          }
        };

    $(this).ajaxSubmit(options);

    return false;
  },

  sendAtpData: function() {
    $('.ph-atpresponse-error').hide();

    var userSelection = [],
        atpItemCount = $('#atpItemCount').val(),
        $deliverymodes = $('#deliverymodes');

    if (atpItemCount > 1) {
      $deliverymodes.find('.atpItem').each(function() {
        var itemIndex = $(this).val(),
            productid = $(this).attr('data-productid'),
            quantityavailable = $(this).attr('data-quantityavailable'),
            selectionValue = 'Split Shipment';

        if ($deliverymodes.find('#atp-product' + itemIndex).is(':checked')) {
          selectionValue = 'One Shipment';
        }

        if (!$deliverymodes.find('.ph-deliverymode__custommultiple #radio3').is(':checked')) {
          selectionValue = $deliverymodes.find('input[name=completeDelivery]:checked').val();
        }

        var selectionValueWrapped = selectionValue + ';' + productid + ';' + quantityavailable;

        userSelection.push(selectionValueWrapped);
      });
    } else if (atpItemCount > 0) {
      var selectionValue = $deliverymodes.find('input[name=completeDelivery]:checked').val(),
          productid = $deliverymodes.find('#atpItemIndex0').attr('data-productid'),
          quantityavailable = $deliverymodes.find('#atpItemIndex0').attr('data-quantityavailable'),
          selectionValueWrapped = selectionValue + ';' + productid + ';' + quantityavailable;

      userSelection.push(selectionValueWrapped);
    }

    if (atpItemCount > 0 && $deliverymodes.find('input[name=completeDelivery]').is(':checked')) {
      $.ajax({
        type: 'POST',
        url: $('.ph-setAtpDeliveryDecisionUrl').text(),
        dataType: 'json',
        async: false,
        data: {
          atpProductAndDeliveryDecisions: userSelection.toString()
        },
        error: function() {
          $('.ph-atpresponse-error').show();
          $deliverymodes.find('input[name=completeDelivery]').prop('checked', false);
        }
      });
    }
  },
  showAtpPopup: function(data) {
    $.colorbox({
      inline: true,
      href: $('.ph-atppopupcontent').html(),
      scrolling: true,
      maxHeight: 450,
      maxWidth: '90%',
      escKey: false,
      overlayClose: false,
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('#colorbox').find('.ph-atpbuttons').click(function() {
          var userSelection = [],
              atpProductAndDeliveryDecisions = [];

          $('#colorbox').find('.ph-atpradiobutton').each(function() {
            if ($(this).is(':checked')) {
              userSelection.push($(this).val());
            }
          });

          if (data.customerDecision.length === userSelection.length) {
            atpProductAndDeliveryDecisions = userSelection;
            $.ajax({
              type: 'POST',
              url: $('.ph-setAtpDeliveryDecisionUrl').text(),
              dataType: 'json',
              data: {
                atpProductAndDeliveryDecisions: atpProductAndDeliveryDecisions.toString()
              },
              success: function(result) {
                $.colorbox.close();

                /* eslint-disable  no-undefined */
                if (result.philipsATPData !== null || result.philipsATPData === undefined) {
                  /* eslint-enable  no-undefined */
                  location.href = escape(location.pathname);
                }
              }
            });
          } else {
            if ($('#cboxContent ').find('.ph-errorselection').length > 0) {
              $('#cboxContent ').find('.ph-errorselection').remove();
            }

            $('.ph-errorselection').show().insertBefore($('.ph-deliveryatp-error0'));
          }
        });
      }

    });
  },
  showSelectedAddress: function(data) {
    if (data) {
      var key = 'deliveryAddress',
          haveDefaultAddress = 'haveDefaultAddress',
          displayCodeRegionIso = 'displayCodeRegionIso',
          deliveryAddress = {};

      if (data.addressData) {
        deliveryAddress[key] = data.addressData;
      } else {
        deliveryAddress[key] = data;
      }

      deliveryAddress[haveDefaultAddress] = $('#haveDefaultAddress').val();
      deliveryAddress[displayCodeRegionIso] = $(ACC.address.showRegion).html();
      ACC.address.refreshDeliveryAddressSection(deliveryAddress);
    }

    $('.ph-default-address__title').show();
    $('.ph-default-address__info').show();
    $('.ph-selectaddress-button .ph-deliveryaddress__change').show();
    $('.ph-selectaddress-button .ph-deliveryaddress__select').hide();
    $('.ph-checkout_shiping__dropship').hide();
    $('.ph-selectaddress-error').hide();
    $('#deliveryAddressOk').val('true');

    $('#cboxClose').css('display', 'none');
  },

  handleSelectExitingAddressSuccess: function(data) {
    if (data !== null) {
      ACC.address.showSelectedAddress(data);
      location.href = escape(location.pathname);
    }
  },
  bindCreateUpdateAddressForm: function() {
    $('.create_update_address_form').each(function() {
      var options = {
        type: 'POST',
        beforeSubmit: function() {
          $('#checkout_delivery_address').block({
            message: '<img src=\'' + $('.ph-spinnerUrl').text() + '\' />'
          });
          $.colorbox.toggleLoadingOverlay();
        },
        success: function(data) {
          $('#create_update_address_form_container_div').html(data);

          var status = $('.create_update_address_id').attr('status');

          if (status !== null && status.toLowerCase() === 'success') {
            ACC.refresh.getCheckoutCartDataAndRefreshPage();
            parent.$.colorbox.close();
          } else {
            ACC.address.bindCreateUpdateAddressForm();
          }
        },
        complete: function() {
          $('#checkout_delivery_address').unblock();
          $.colorbox.toggleLoadingOverlay();
        }
      };

      $(this).ajaxForm(options);
    });
  },

  refreshDeliveryAddressSection: function(data) {
    $('#checkout_summary_deliveryaddress_div').replaceWith($('#deliveryAddressSummaryTemplate').tmpl(data));

    // Bind change address button
    $('div.checkout_summary_flow_c .change_address_button').click(this.handleChangeAddressButtonClick);
  },

  validateOneTimeAddress: function() {
    var count = 0,
        alphabeticErrorMsg = $('.ph-alphabeticErrorMsg').text();

    $('.alert').remove();

    if (ACC.validation.userName($.trim($('#name').val()))) {
      count = count + 1;
      $('#name').parent().append($('.ph-userNameErrorMsg').text());
    }

    if (ACC.validation.alphanumeric($.trim($('#addressLine1').val()))) {
      count = count + 1;
      $('#addressLine1').parent().append(alphabeticErrorMsg);
    }

    if (ACC.validation.alphanumeric($.trim($('#addressLine2').val()))) {
      count = count + 1;
      $('#addressLine2').parent().append(alphabeticErrorMsg);
    }

    if (ACC.validation.alpha($.trim($('#city').val()))) {
      count = count + 1;
      $('#city').parent().append(alphabeticErrorMsg);
    }

    if (count === 0) {
      return true;
    }

    return false;
  }

};

$(document).ready(function() {
  if ($('.ph-onestore_checkout').length === 0) {
    ACC.address.bindAll();
    $('html').removeClass('ph-hideoverflow__shippingpopup');

    if ($('#prefilDeliveryAddress').val() === 'true') {
      var addressId = $('.ph-deliveryaddress').attr(ACC.address.dataAddress);

      $.postJSON($('.ph-setDeliveryAddressUrl').text(), {
        addressId: addressId
      }, function(data) {
        if (data !== null) {
          ACC.address.showSelectedAddress(data);
        }
      });
    }
  }

  function resizeColorBox() {
    var resizeTimer = setTimeout(function() {
      if ($('#cboxOverlay').is(':visible')) {
        $.colorbox.load(true);
      }
    }, 100);

    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
  }

  window.addEventListener('orientationchange', resizeColorBox, false);
});
